// 수납 내역 관리 > 결제 내역 리스트 + CSV 양식 다운로드 / 일괄 업로드

import { Link } from "react-router-dom";
import { useState } from "react";

import * as API from "../../service/api";
import * as APIURL from "../../service/string/apiUrl";
import * as MO from "../../service/library/modal";
import * as TOA from "../../service/library/toast";
import * as RAN from "../../service/useData/rander";

import PaginationButton from "../../components/services/ServicesPaginationButton_Redux";
import ComponentListPaymentHistorySearch from "../../components/common/ComponentListPaymentHistorySearch";
import ComponentErrorNull from "../../components/piece/PieceErrorNull";
import ComponentLoading from "../../components/piece/PieceLoading";

export default function ListPaymentHistory() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  // CSV 양식 헤더 ( 한글 표기 )
  // 백엔드 savePaymentCSVData 는 첫 줄(머리글)을 건너뛰고 '컬럼 순서'로 파싱하므로
  // 라벨은 한글로 바꿔도 무방하나 컬럼 순서는 반드시 아래대로 유지해야 함
  // ( cid, uid, startDate, paymentDate, billYM, amount, payment, chargeType )
  const csvData = [
    [
      "관리번호",
      "회원번호",
      "선납시작일",
      "출금일",
      "청구년월",
      "금액",
      "결제방법",
      "결제방식",
    ],
  ];

  const generateCSV = () => {
    const csvContent = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob(["﻿" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "gongsacokpaymentdata.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function handleUpload(e) {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("csvFile", file);

    MO.servicesUseModalCsvUpload(
      `${file.name} 파일을 업로드 하시겠습니까?`,
      "추가를 누르시면 결제 내역이 추가됩니다.",
      () => {
        setLoading(true);
        API.servicesPostDataForm(APIURL.urlUploadPaymentCsv, formData).then(
          (res) => {
            try {
              setLoading(false);
              if (res.status === "success") {
                TOA.servicesUseToast("등록이 완료되었습니다!", "s");
                RAN.serviesAfter1secondReload();
              } else {
                alert(res.emsg);
              }
            } catch {
              TOA.servicesUseToast(res.emsg, "e");
              setLoading(false);
            }
          }
        );
      },
      () => console.log("닫기!")
    );

    // 같은 파일 재업로드 가능하도록 초기화
    e.target.value = "";
  }

  return (
    <>
      <ComponentLoading loading={loading} bg />
      <ComponentListPaymentHistorySearch setList={setList} />

      <form className="listSearchForm formLayout">
        <div className="listSearchButtonWrap">
          <button
            type="button"
            onClick={generateCSV}
            style={{ width: "190px" }}
          >
            결제내역 입력폼 다운로드
          </button>

          <label
            htmlFor="paymentCsvUpload"
            style={{ width: "150px" }}
            className="basicModifyBtn"
          >
            결제내역 업로드
          </label>
          <input
            className="blind"
            id="paymentCsvUpload"
            type="file"
            accept=".csv"
            onChange={handleUpload}
          />
        </div>
      </form>

      {(list == [] && list.length == 0) || list === undefined ? (
        <ComponentErrorNull />
      ) : (
        <section className="tableWrap">
          <h3 className="blind">table</h3>
          <div className="paddingBox commonBox">
            <table className="commonTable">
              <thead>
                <tr>
                  <th style={{ width: "70px" }}>관리번호</th>
                  <th style={{ width: "auto" }}>상호명</th>
                  <th style={{ width: "120px" }}>휴대폰</th>
                  <th style={{ width: "90px" }}>가입자명</th>
                  <th style={{ width: "80px" }}>청구년월</th>
                  <th style={{ width: "90px" }}>금액</th>
                  <th style={{ width: "90px" }}>결제방법</th>
                  <th style={{ width: "120px" }}>결제방식</th>
                  <th style={{ width: "100px" }}>선납 시작일</th>
                  <th style={{ width: "100px" }}>출금일</th>
                  <th style={{ width: "90px" }}>비고</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 &&
                  list.map((item, key) => (
                    <tr key={key}>
                      <td className="tableButton">
                        <Link
                          to={`/company/${item.cid}`}
                          className="Link"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          {item.cid}
                        </Link>
                      </td>
                      <td>{item.name}</td>
                      <td>{item.mobilenum}</td>
                      <td>{item.regOwner}</td>
                      <td>{item.billYM}</td>
                      <td>
                        {item.amount != null
                          ? Number(item.amount).toLocaleString()
                          : ""}
                      </td>
                      <td>{item.payment}</td>
                      <td>{item.chargeType}</td>
                      <td>{item.startDate && item.startDate.slice(0, 10)}</td>
                      <td>
                        {item.paymentDate && item.paymentDate.slice(0, 10)}
                      </td>
                      <td>{item.remark}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {list.length > 0 && <PaginationButton />}
          </div>
        </section>
      )}
    </>
  );
}
